import _styled from "@emotion/styled/base";
/* eslint-disable react/no-unused-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { StyledCacheWrapper, utilityStyles } from '../../styles';
var propTypes = {
  /** Add utility objects for styling */
  utils: PropTypes.object
};
var defaultProps = {
  utils: {}
};

/**
 * @ignore @description
 * ## Utility Component
 * Utility component allows you to use our utils prop on any HTML element. Replace your regular HTML tags with <Utility.[TAG_NAME]>, for example <Utility.Div /> instead of <div />. All props will be spread onto the tag as normal.
 *
 * @ignore @see Mesh: [Utility Docs](https://mesh-component-library.apps.csts-k8cnp-ro-1.r-caas.allstate.com/?path=/docs/utils-utility--page)
 *
 * @ignore @example
 * ```jsx
 * import { Utility } from 'mesh-component-library';
 *
 * <Utility {...props} />
 * ```
 */
var Utility = function Utility() {
  return /*#__PURE__*/React.createElement(React.Fragment, null);
};
var tags = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr',
// SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];
tags.forEach(function (tag) {
  var tagName = tag.charAt(0).toUpperCase() + tag.slice(1);
  var StyledEl = /*#__PURE__*/_styled(tag, process.env.NODE_ENV === "production" ? {
    target: "efn6mcx0"
  } : {
    target: "efn6mcx0",
    label: "StyledEl"
  })(utilityStyles);
  var resp = function resp(props) {
    return /*#__PURE__*/React.createElement(StyledCacheWrapper, null, /*#__PURE__*/React.createElement(StyledEl, props));
  };
  resp.displayName = "Utility.".concat(tagName);
  Utility[tagName] = resp;
});
Utility.defaultProps = defaultProps;
Utility.propTypes = propTypes;
export default Utility;